import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"

import {
  Card,
  CardBody,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
} from "reactstrap"

import {
  AvForm,
  AvField,
  AvRadio,
  AvRadioGroup,
} from "availity-reactstrap-validation"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "./styles.css"

// plastics auth service
import PlasticsApplication from "../../services/PlasticsApplication.service"

import DecisionInfo from "components/Services/environment/en/DecisionInfo"
import ViewFiles from "components/Services/environment/en/ViewFiles"
import General from "services/GeneralEndpoints"
import AuthPlasticsPreview from "components/Preview/AuthPlastics.preview"
import ConsumptionItems from "components/Services/FormComponents/ConsumptionItems"
import OtherConsumptionItems from "components/Services/FormComponents/OtherConsumptionItems"

var countriesJson = require("../../assets/files/countries.json")

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES
const BASE_URL = process.env.REACT_APP_BASE_URL

const user = JSON.parse(localStorage.getItem("authUser"))
const plasticsApp = new PlasticsApplication(user)
let generalService = new General(user)

const FormWizard = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [progressValue, setprogressValue] = useState(25)
  const [activeTabVartical, setoggleTabVertical] = useState(1)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [plasticTypes, setplasticTypes] = useState([])
  const [packageImage, setpackageImage] = useState()
  const [productImage, setproductImage] = useState()

  const [selectedFiles, setselectedFiles] = useState([])
  const [uploadedImages, setUploadedImages] = useState([])
  const [alreadySubmitted, setalreadySubmitted] = useState(false)

  const plasticsFormRef = useRef(null)
  const attachmentsFormRef = useRef(null)

  // consumption areas
  const [consumptionAreas, setconsumptionAreas] = useState([])

  // added test comment

  // form attachments
  const [serviceAttachments, setserviceAttachments] = useState([])
  const [serviceAttachmentsRaw, setserviceAttachmentsRaw] = useState([])
  const [uploadedFiles, setuploadedFiles] = useState([])

  // form attributes
  const [applicationId, setapplicationId] = useState()
  const [loading, setloading] = useState(false)
  const [submitted, setsubmitted] = useState(false)
  const [error, seterror] = useState()
  const [applicationDetails, setApplicationDetails] = useState({})
  const [applicationType, setApplicationType] = useState()

  // Changes Oct 15 2022
  const [localSuppliers, setlocalSuppliers] = useState([])
  const [localSuppliersRaw, setlocalSuppliersRaw] = useState([])
  const [showLocalSuppliers, setshowLocalSuppliers] = useState(false)
  const [consumptionAreaItems, setconsumptionAreaItems] = useState([])
  const [importPurchase, setimportPurchase] = useState({
    purchase: true,
    import: false,
    import_single: false,
    purchase_single: false,
  })
  const [applicantConsumptionAreaItems, setapplicantConsumptionAreaItems] =
    useState([])

  const [importPurchaseUpdate, setimportPurchaseUpdate] = useState("")

  // submitted Application Details
  const [submittedApplication, setsubmittedApplication] = useState()
  const [submittedFormData, setsubmittedFormData] = useState({})
  const [disableFormFields, setdisableFormFields] = useState(false)
  const [currentPath, setcurrentPath] = useState(
    window.location.pathname + props.location.search
  )
  const [showDecisionInfo, setshowDecisionInfo] = useState(false)
  const [decisionInfo, setDecisionInfo] = useState({})
  const [reuploadDocs, setreuploadDocs] = useState(false)
  const [isReturned, setisReturned] = useState(false)
  const [documentsPane, setdocumentsPane] = useState(<div></div>)
  const [cancelUpload, setcancelUpload] = useState(false)
  const [isFreshApplication, setisFreshApplication] = useState(true)
  const [companies, setcompanies] = useState()
  const [companyId, setcompanyId] = useState()
  const [measures, setmeasures] = useState()
  const [measureId, setmeasureId] = useState("")
  const [consumptionId, setconsumptionId] = useState("")
  const [showDocuments, setshowDocuments] = useState(false)

  const [plasticTypesRaw, setplasticTypesRaw] = useState()
  const [measuresRaw, setmeasuresRaw] = useState()
  const [editMode, seteditMode] = useState(false)
  const [countries, setcountries] = useState()
  const [usagePreview, setusagePreview] = useState("")

  const [hideOtherPlasticTypeName, sethideOtherPlasticTypeName] = useState(true)
  const [plasticNameUpdate, setplasticNameUpdate] = useState("")
  const [hideOtherConsumptionTypeName, sethideOtherConsumptionTypeName] =
    useState(true)
  const [consumptionTypeColumn, setconsumptionTypeColumn] = useState(6)

  // changes April 5, 2023
  const [consumptionAreaOtherItems, setconsumptionAreaOtherItems] = useState({
    count: 0,
    data: [],
  })
  const [countOtherItems, setcountOtherItems] = useState(0)
  const [renderOtherItems, setrenderOtherItems] = useState(false)
  const [itemsUsage, setitemsUsage] = useState("")
  const [showPieces, setshowPieces] = useState(false)
  const [isMedicalUse, setisMedicalUse] = useState(false)

  // Regex patterns
  const ID_NUMBER_REGEX = {
    value: "/^[0-9]{16}$/",
    errorMessage: "Your ID number must be 16 digits!",
  }

  useEffect(() => {}, [JSON.stringify(consumptionAreaOtherItems)])

  useEffect(() => {}, [submittedFormData])

  useEffect(() => {}, [consumptionAreaItems])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    setuser(userObj)
    fetchCompanies()
    fetchQuantityMeasures()
    fetchConsumptionAreas()
    setCountriesSelectBox()
    fetchLocalSuppliers()

    if (
      currentPath.includes("view-application") ||
      currentPath.includes("edit-application")
    ) {
      //show decision info card
      setshowDecisionInfo(true)
      setapplicationId(props.location.search.split("=")[1])

      plasticsApp
        .getApplicationDetails(props.location.search.split("=")[1])
        .then(response => {
          if (response.status) {
            //check whether application status is return back to applicant
            //if return to applicant set edit mode to true

            // set import purchase
            var data = {
              purchase: response.data.auth_plastic_bags.purchase,
              import: response.data.auth_plastic_bags.import,
              import_single: response.data.auth_plastic_bags.import_single,
              purchase_single: response.data.auth_plastic_bags.purchase_single,
            }
            // console.log("app details", response.data)
            if (data.purchase) {
              setimportPurchaseUpdate("purchase")
            } else if (data.import) {
              setimportPurchaseUpdate("import")
            } else if (data.import_single) {
              setimportPurchaseUpdate("import_single")
            } else if (data.purchase_single) {
              setimportPurchaseUpdate("purchase_single")
            }

            setimportPurchase(data)

            // is applicant using local supplier?
            if (response.data.auth_plastic_bags.local_supplier_id != null) {
              setshowLocalSuppliers(true)
            }

            // get consumption area items
            // fetch items in consumption area
            var user_selected_items =
              response.data.application_consumption_area_items
            plasticsApp
              .getConsumptionAreaItems(
                response.data.auth_plastic_bags.consumption_area_id
              )
              .then(response => {
                if (response.status) {
                  var items = response.data.map(item => {
                    return {
                      id: item.id,
                      name: item.name,
                      checked: false,
                    }
                  })
                  

                  const user_items = user_selected_items.map(item => {
                    return {
                      id: item.consumption_area_item.id,
                      name: item.consumption_area_item.name,
                      checked: true,
                    }
                  })

                  var mergedConsumptionItems = items.concat(user_items)

                  // remove duplicates
                  let filteredItems = mergedConsumptionItems.filter(
                    (ele, ind) =>
                      ind ===
                      mergedConsumptionItems.findIndex(
                        elem => elem.jobid === ele.jobid && elem.id === ele.id
                      )
                  )

                  // selected consumption area items
                  var selected_items = user_selected_items.map(
                    item => item.consumption_area_item_id
                  )
                  filteredItems.forEach(item => {
                    if (selected_items.includes(item.id)) {
                      item.checked = true
                    }
                  })

                  setconsumptionAreaItems(filteredItems)
                }
              })

            setmeasureId(response.data.auth_plastic_bags.quantity_measure_id)

            setconsumptionId(
              response.data.auth_plastic_bags.consumption_area_id
            )

            if (response.data.auth_plastic_bags.company_id != null) {
              setApplicationType("company")
              setcompanyId(response.data.auth_plastic_bags.company_id)
            } else {
              setApplicationType("individual")
            }

            if (response.data.application_status_id === 7) {
              setisFreshApplication(false)
              setdisableFormFields(false)
              setisReturned(true)
              setshowDocuments(true)
              seteditMode(true)
              setrenderOtherItems(true)
            } else {
              setisFreshApplication(false)
              setdisableFormFields(true)
              setshowDocuments(true)
            }

            let plastic_type_name = ""
            if (response.data.auth_plastic_bags.other_plastic_type == null) {
              plastic_type_name =
                response.data.auth_plastic_bags.plastic_type.name
            } else {
              plastic_type_name =
                response.data.auth_plastic_bags.other_plastic_type
            }

            setsubmittedFormData({
              company_name: response.data.auth_plastic_bags.company_name,
              company_representative:
                response.data.auth_plastic_bags.company_representative,
              contact_telephone:
                response.data.auth_plastic_bags.contact_telephone,
              tin: response.data.auth_plastic_bags.tin,
              usage: response.data.auth_plastic_bags.consumption_area.name,
              quantity: response.data.auth_plastic_bags.quantity,
              plastic_type_id: response.data.auth_plastic_bags.plastic_type_id,
              origin: response.data.auth_plastic_bags.origin,
              is_company: response.data.auth_plastic_bags.is_company,
              description: response.data.auth_plastic_bags.description,
              other_plastic_type:
                response.data.auth_plastic_bags.other_plastic_type,
              other_consumption_area:
                response.data.auth_plastic_bags.other_consumption_area,
              local_supplier_id:
                response.data.auth_plastic_bags.local_supplier_id,
              measure_name:
                response.data.auth_plastic_bags.quantity_measure.name,
              plastic_type_name: plastic_type_name,
              plastics_finished_usage:
                response.data.auth_plastic_bags.plastics_finished_usage,
              piece_weight: response.data.auth_plastic_bags.piece_weight,
              manually_processed: response.data.manually_processed,
            })

            if (response.data.auth_plastic_bags.piece_weight != null) {
              setshowPieces(true)
            } else {
              setshowPieces(false)
            }

            setplasticNameUpdate(plastic_type_name)

            // set dynamic textboxes
            if (response.data.auth_plastic_bags.plastic_type.name === "Other") {
              sethideOtherPlasticTypeName(false)
            }
            if (
              response.data.auth_plastic_bags.consumption_area.name === "Other"
            ) {
              sethideOtherConsumptionTypeName(false)
              setconsumptionTypeColumn(4)
            }

            let comments = ""
            let certUrl = "#"
            if (response.data.application_status_id === 7) {
              // get comments from officer
              response.data.application_flow_histories.forEach(hist => {
                if (hist.application_status_id === 7) {
                  comments = hist.comment_to_applicant
                }
              })
            }

            if (response.data.application_status_id === 6) {
              // get certificate download url
              if (
                response.data.manually_processed != undefined &&
                response.data.manually_processed == true
              ) {
                certUrl = STATIC_FILES + response.data.manually_processed.path
              } else {
                certUrl =
                  BASE_URL + "verify/certificate/" + response.data.app_id
              }
            }

            // set decision info
            setDecisionInfo({
              statusId: response.data.application_status_id,
              status: response.data.application_status.name,
              service: response.data.service.name,
              comments: comments,
              certUrl: certUrl,
              isManuallyProcessed: response.data.manually_processed,
              manual_certificate: response.data.manual_certificate,
              final_certificate_uploaded:
                response.data.final_certificate_uploaded,
            })

            // set uploaded images
            setUploadedImages(response.data.application_attachments)

            setusagePreview(
              response.data.auth_plastic_bags.consumption_area.name
            )
          }
        })
    } else {
      plasticsApp.createApplication(userObj).then(response => {
        setapplicationId(response.data.id)
        seteditMode(true)
      })
    }

    // get service attachments
    plasticsApp.getServiceAttachments().then(response => {
      //
      if (response.status) {
        const attachments = response.data.map((attachment, index) => (
          <Row key={index}>
            <span>{attachment.description}</span>
            <input
              type="file"
              id={attachment.name}
              required={attachment.is_mandatory}
              accept=".pdf,image/*,.doc,.docx"
            />
          </Row>
        ))
        setserviceAttachments(attachments)
        setserviceAttachmentsRaw(response.data)
      }
    })

    // get plastic types
    plasticsApp.getPlasticTypes().then(response => {
      const options = response.data.map((type, index) => (
        <option key={index} value={type.id}>
          {type.name}
        </option>
      ))
      setplasticTypes(options)
      setplasticTypesRaw(response.data)
      setmounted(true)
    })

    // Get service attachments
  }, [])

  useEffect(() => {
    // set documents pane
    setcancelUpload(true)
  }, [serviceAttachments])

  const showUploadedFiles = () => {
    setcancelUpload(false)
    setshowDocuments(true)
  }

  const initiateReupload = () => {
    setshowDocuments(false)
    setcancelUpload(false)
  }

  const submitApplication = () => {
    var uploaded_files = []

    setloading(true)
    uploadedFiles.forEach(attach => {
      uploaded_files.push({
        application_id: applicationId,
        description: attach.description,
        file: attach.file,
      })
    })

    plasticsApp
      .saveApplication({
        ...applicationDetails,
        application_id: applicationId,
        ...importPurchase,
      })
      .then(response => {
        if (response) {
          if (isReturned && !showDocuments) {
            plasticsApp.bulkFileUpload(uploaded_files)
          } else if (isFreshApplication) {
            plasticsApp.bulkFileUpload(uploaded_files)
          }
          setsubmitted(true)
        } else {
          seterror("Error encountered while submitting application")
          setloading(false)
        }
      })
  }

  const validateApplicationDetails = formData => {
    let plastic_type_name = ""
    let measure_name = ""

    // console.log("form data", formData)

    plasticTypesRaw.forEach(element => {
      if ("" + element.id + "" === formData.plastic_type_id) {
        plastic_type_name = element.name
      }
    })

    if (plastic_type_name == "") {
      plastic_type_name = submittedFormData.plastic_type_name
    }

    measuresRaw.forEach(element => {
      if ("" + element.id + "" === formData.quantity_measure_id) {
        measure_name = element.name
      }
    })

    if (measure_name == "") {
      measure_name = submittedFormData.measure_name
    }

    var supplier_company_name = ""
    localSuppliersRaw.forEach(element => {
      if ("" + element.id + "" === formData.local_supplier_id) {
        supplier_company_name = element.name
      }
    })

    // get consumption area items
    // consumption area items will be an array of item ids

    var consumptionItems = consumptionAreaItems
      .filter(item => item.checked)
      .map(item => {
        return item.id
      })

    var consumptionItemsNames = consumptionAreaItems
      .filter(item => item.checked)
      .map(item => {
        return item.name
      })

    var other_selected_items_names = consumptionAreaOtherItems.data
      .filter(item => item.checked)
      .map(item => item.name)

    var other_selected_items = consumptionAreaOtherItems.data
      .filter(item => item.checked)
      .map(item => item)

    // If single use plastics are for medical use, then consumption area items are not required.
    if (!isMedicalUse) {
      if (consumptionItems.length < 1 && other_selected_items.length < 1) {
        alert("Please choose the items you will be packaging")
        return
      }
    }

    setApplicationDetails({
      ...formData,
      measure_name: measure_name,
      plastic_type_name: plastic_type_name,
      usage: usagePreview,
      consumption_area_items: consumptionItems,
      other_selected_items: other_selected_items,
      other_selected_items_names: other_selected_items_names,
      consumptionItemsNames: consumptionItemsNames,
      ...importPurchase,
      supplier_company_name: supplier_company_name,
    })

    setactiveTab(2)
  }

  const onChangeProductImage = event => {
    setproductImage(event.target.files[0])
  }

  const onChangePackageImage = event => {
    setpackageImage(event.target.files[0])
  }

  const prepareUploadFiles = e => {
    let current_attachments = []
    let kount = 0
    for (kount = 0; kount < serviceAttachments.length; kount++) {
      if (e.target[kount].files.length > 0) {
        current_attachments.push({
          application_id: applicationId,
          description: e.target[kount].id,
          file: e.target[kount].files[0],
        })
      }
    }
    // console.log("upload files", current_attachments)
    setuploadedFiles(current_attachments)
    setactiveTab(3)
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      // console.log(response)
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }

  const fetchQuantityMeasures = () => {
    generalService.getQuantityMeasures().then(response => {
      if (response.status) {
        const meas = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setmeasures(meas)
        setmeasuresRaw(response.data)
      }
    })
  }

  const fetchConsumptionAreas = () => {
    plasticsApp.getConsumptionAreas().then(response => {
      if (response.status) {
        const areas = response.data
          .filter(item => item.name != "Other" && item.name != "Meet Supplying")
          .map((item, index) => {
            return (
              <option key={index} value={item.id}>
                {item.name}
              </option>
            )
          })

        setconsumptionAreas(areas)
      }
    })
  }

  const onChangePlasticType = event => {
    if (event.target.value !== "") {
      // get plastic name
      var plasticTypeName =
        event.target.options[event.target.selectedIndex].text

      if (plasticTypeName == "Other") {
        sethideOtherPlasticTypeName(false)
      } else {
        sethideOtherPlasticTypeName(true)
      }

      setplasticNameUpdate(plasticTypeName)
    }
  }

  const setCountriesSelectBox = () => {
    const countries = countriesJson.map((item, index) => {
      return (
        <option key={index} value={item.name}>
          {item.name}
        </option>
      )
    })

    setcountries(countries)
  }

  const onChangeConsumptionArea = e => {
    const area_name = e.target.options[e.target.selectedIndex].text
    setusagePreview(area_name)

    if (area_name == "Medical Use") {
      setisMedicalUse(true)
    } else {
      setisMedicalUse(false)
    }

    setitemsUsage("Choose the items to be used for " + area_name)

    setconsumptionId(e.target.value)
    setrenderOtherItems(true)

    // fetch items in consumption area
    plasticsApp.getConsumptionAreaItems(e.target.value).then(response => {
      if (response.status) {
        const items = response.data.map(item => {
          return {
            id: item.id,
            name: item.name,
            checked: false,
          }
        })

        setconsumptionAreaItems(items)
      }
    })

    if (area_name == "Other") {
      setconsumptionTypeColumn(4)
      sethideOtherConsumptionTypeName(false)
    } else {
      setconsumptionTypeColumn(6)
      sethideOtherConsumptionTypeName(true)
    }

    // changes April 5, 2023
    // If consumption area changes, set other items to empty
    setconsumptionAreaOtherItems({ count: 0, data: [] })
  }

  const updateConsumptionItems = (index, status) => {
    var items = consumptionAreaItems
    items[index]["checked"] = status

    setconsumptionAreaItems(items)
  }

  const addOtherConsumptionItems = item => {
    let items = consumptionAreaOtherItems.data
    if (items.includes(item)) {
      return
    }
    items.push({ id: null, name: item, checked: true })
    setconsumptionAreaOtherItems({ count: items.length, data: items })
  }

  const updateOtherConsumptionItems = itemIndex => {
    let items = consumptionAreaOtherItems.data

    items[itemIndex]["checked"] = !items[itemIndex]["checked"]

    setconsumptionAreaOtherItems({ count: items.length, data: items })
  }

  // Changes Oct 15 2022
  const fetchLocalSuppliers = () => {
    plasticsApp.getLocalSuppliers().then(response => {
      if (response.status) {
        const suppliers = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setlocalSuppliers(suppliers)
        setlocalSuppliersRaw(response.data)
      }
    })
  }

  const onChangeImportPurchase = e => {
    var type = e.target.value
    type = type.toLowerCase()

    // data to send to backend
    // In the backend, there are four fields for import/purchase
    // import and use single-use plastics
    // Purchase and use single-use plastics

    // import and use plastic carry bags
    // Purchase and use plastic carry bags

    var data = {
      purchase: false,
      import: false,
      import_single: false,
      purchase_single: false,
    }

    if (type === "purchase" || type === "purchase_single") {
      setshowLocalSuppliers(true)
    } else {
      setshowLocalSuppliers(false)
    }

    if (e.target.value === "") {
      return
    } else {
      data[e.target.value] = true
      setimportPurchase(data)
      // set data
    }
  }

  const handleQuantityMeasureChange = e => {
    const pieces = measuresRaw
      .filter(item => item.name == "Pieces")
      .map(item => {
        return { id: item.id, name: item.name }
      })

    if (pieces.length > 0) {
      if (pieces[0].id == e.target.value) {
        setshowPieces(true)
      } else {
        setshowPieces(false)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Apply | Authorization</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Application"
            breadcrumbItem="Authorization to use plastics"
          />

          {showDecisionInfo ? (
            <Row>
              <Col sm="12">
                <DecisionInfo data={decisionInfo} />
              </Col>
            </Row>
          ) : (
            ""
          )}

          {!submitted ? (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">
                      Application for Authorization to use Plastics
                    </h4>
                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                //setactiveTab(1)
                              }}
                            >
                              <span className="number">1.</span> Application
                              Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                //setactiveTab(2)
                              }}
                            >
                              <span className="number">2.</span> Document
                              Uploads
                            </NavLink>
                          </NavItem>

                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                //setactiveTab(3)
                              }}
                            >
                              <span className="number">3.</span>
                              Confirm Detail
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <AvForm
                              onValidSubmit={(e, v) => {
                                validateApplicationDetails(v)
                              }}
                              model={submittedFormData}
                            >
                              {error ? (
                                <Alert color="danger">{error}</Alert>
                              ) : null}

                              <Row>
                                <Col md={12}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="application_type"
                                        label="Select Applicant Type"
                                        value={applicationType}
                                        required
                                        disabled={disableFormFields}
                                        onChange={e => {
                                          setApplicationType(e.target.value)
                                        }}
                                      >
                                        <option value="">--select--</option>
                                        <option value="company">Company</option>
                                        <option value="individual">
                                          Individual
                                        </option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>

                                {applicationType === "individual" ? (
                                  <Col md={12}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="text"
                                          name="tin"
                                          label="Identification Number"
                                          value={
                                            submittedFormData.tin
                                              ? submittedFormData.tin
                                              : ""
                                          }
                                          required
                                          disabled={disableFormFields}
                                          validate={{
                                            pattern: ID_NUMBER_REGEX,
                                          }}
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                ) : (
                                  <Col md="12">
                                    {applicationType === "company" ? (
                                      <>
                                        <Row>
                                          <AvField
                                            type="select"
                                            name="company_id"
                                            label="Select Company"
                                            required
                                            value={companyId}
                                            disabled={disableFormFields}
                                          >
                                            <option>--Select Company</option>
                                            {companies}
                                          </AvField>
                                        </Row>
                                      </>
                                    ) : null}
                                  </Col>
                                )}
                              </Row>

                              <Row>
                                <Col md={12}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        onChange={onChangePlasticType}
                                        type="select"
                                        name="plastic_type_id"
                                        label="Select Plastic Type"
                                        value={
                                          submittedFormData.plastic_type_id
                                            ? submittedFormData.plastic_type_id
                                            : ""
                                        }
                                        required
                                        disabled={disableFormFields}
                                      >
                                        <option value="">--select--</option>
                                        {plasticTypes}
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                {!hideOtherPlasticTypeName ? (
                                  <Col md={12}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          name="other_plastic_type"
                                          type="text"
                                          className="form-control"
                                          label="Other Plastic type name"
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            submittedFormData.other_plastic_type
                                              ? submittedFormData.other_plastic_type
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                ) : null}
                              </Row>

                              <Row>
                                <Col md={12}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="import_purchase"
                                        label="For Import/Purchase"
                                        onChange={onChangeImportPurchase}
                                        required
                                        value={importPurchaseUpdate}
                                        disabled={disableFormFields}
                                      >
                                        <option value="">--select--</option>
                                        <option value="import_single">
                                          Import and Use Single-Use Plastics
                                        </option>
                                        <option value="purchase_single">
                                          Purchase and Use Single-Use Plastics
                                        </option>
                                        <option value="import">
                                          Import and Use Plastic Carry Bags
                                        </option>
                                        <option value="purchase">
                                          Purchase and Use Plastic Carry Bags
                                        </option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={12}>
                                  {showLocalSuppliers ? (
                                    <Row>
                                      <div>
                                        <AvField
                                          type="select"
                                          name="local_supplier_id"
                                          label="Select Local Supplier"
                                          required
                                          value={
                                            submittedFormData.local_supplier_id
                                              ? submittedFormData.local_supplier_id
                                              : ""
                                          }
                                          disabled={disableFormFields}
                                          onChange={onChangeConsumptionArea}
                                        >
                                          <option value="">--select--</option>
                                          {localSuppliers}
                                        </AvField>
                                      </div>
                                    </Row>
                                  ) : (
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          name="origin"
                                          type="select"
                                          label="Origin of the plastics"
                                          className="form-control"
                                          value={
                                            submittedFormData.origin
                                              ? submittedFormData.origin
                                              : ""
                                          }
                                          required
                                          disabled={disableFormFields}
                                        >
                                          <option>---select--</option>
                                          {countries}
                                        </AvField>
                                      </div>
                                    </Row>
                                  )}
                                </Col>
                              </Row>

                              <Row>
                                <Col md={12}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="quantity_measure_id"
                                        label="Quantity measure"
                                        required
                                        value={measureId}
                                        disabled={disableFormFields}
                                        onChange={handleQuantityMeasureChange}
                                      >
                                        <option value="">--select--</option>
                                        {measures}
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={12}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        name="quantity"
                                        type="number"
                                        className="form-control"
                                        label="Quantity of plastic"
                                        value={
                                          submittedFormData.quantity
                                            ? submittedFormData.quantity
                                            : ""
                                        }
                                        required
                                        disabled={disableFormFields}
                                      />
                                    </div>
                                  </Row>
                                </Col>
                              </Row>
                              {showPieces ? (
                                <Row>
                                  <Col md={12}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="number"
                                          name="piece_weight"
                                          label="Weight of one piece (g)"
                                          required
                                          value={
                                            submittedFormData.piece_weight
                                              ? submittedFormData.piece_weight
                                              : ""
                                          }
                                        ></AvField>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              ) : null}

                              <Row>
                                <Col md={12}>
                                  <input
                                    type="hidden"
                                    name="usage_preview"
                                    value={usagePreview}
                                  />
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="consumption_area_id"
                                        label="Select Application Area"
                                        required
                                        value={consumptionId}
                                        disabled={disableFormFields}
                                        onChange={onChangeConsumptionArea}
                                      >
                                        <option value="">--select--</option>
                                        {consumptionAreas}
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <h5>
                                  Where will the finished product be sold or
                                  used?
                                </h5>
                                <AvRadioGroup
                                  inline
                                  name="plasticsFinishedUsage"
                                  // label="Where will the finished product be sold?"
                                  value={
                                    submittedFormData.plastics_finished_usage
                                      ? submittedFormData.plastics_finished_usage
                                      : ""
                                  }
                                  required
                                >
                                  <AvRadio
                                    customInput
                                    label="Local Sale"
                                    value="Local Sale"
                                  />
                                  <AvRadio
                                    customInput
                                    label="Export"
                                    value="Export"
                                  />
                                  <AvRadio
                                    customInput
                                    label="Both local sale and export"
                                    value="Both"
                                  />
                                </AvRadioGroup>
                              </Row>

                              <Row>
                                {!hideOtherConsumptionTypeName ? (
                                  <Col md={12}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          name="other_consumption_area"
                                          type="text"
                                          className="form-control"
                                          label="Other Consumption type name"
                                          required
                                          disabled={disableFormFields}
                                          value={
                                            submittedFormData.other_consumption_area
                                              ? submittedFormData.other_consumption_area
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                ) : null}
                              </Row>

                              <Row>
                                {consumptionAreaItems.length > 0 ? (
                                  <h5>{itemsUsage}</h5>
                                ) : null}

                                {!isMedicalUse ? (
                                  <div>
                                    <ConsumptionItems
                                      data={consumptionAreaItems}
                                      update={updateConsumptionItems}
                                    />
                                  </div>
                                ) : null}
                              </Row>

                              {renderOtherItems ? (
                                <Row>
                                  {/* <hr></hr> */}
                                  <div>
                                    <OtherConsumptionItems
                                      data={consumptionAreaOtherItems}
                                      add={addOtherConsumptionItems}
                                      update={updateOtherConsumptionItems}
                                    />
                                  </div>
                                </Row>
                              ) : null}

                              <hr></hr>
                              <Row className="mb-3">
                                <Col md={12}>
                                  <AvField
                                    label="Description"
                                    type="textarea"
                                    name="description"
                                    rows="3"
                                    required
                                    className="form-control"
                                    placeholder="Enter description of the plastic"
                                    value={
                                      submittedFormData.description
                                        ? submittedFormData.description
                                        : ""
                                    }
                                    disabled={disableFormFields}
                                  ></AvField>
                                </Col>
                              </Row>

                              <Row style={{ display: "none" }}>
                                <Col md={12}>
                                  <button
                                    ref={plasticsFormRef}
                                    onClick={() => {
                                      // props.onHide()
                                      // setmodal(false)
                                    }}
                                    type="submit"
                                    style={{ float: "right", fontSize: 18 }}
                                    className="btn btn-primary col-3"
                                    disabled={loading}
                                  >
                                    Next
                                  </button>
                                </Col>
                              </Row>
                            </AvForm>
                          </TabPane>
                          <TabPane tabId={2}>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <CardTitle className="h4">
                                      Document Upload
                                    </CardTitle>
                                    {showDocuments ? (
                                      <ViewFiles
                                        attachments={uploadedImages}
                                        isReturned={isReturned}
                                        reupload={initiateReupload}
                                      />
                                    ) : (
                                      <div className="mb-5">
                                        <form
                                          onSubmit={e => {
                                            e.preventDefault()
                                            prepareUploadFiles(e)
                                          }}
                                        >
                                          <Row>
                                            <Col md={12}>
                                              {serviceAttachments}
                                            </Col>
                                          </Row>
                                          {isReturned ? (
                                            <center>
                                              <a
                                                href="#"
                                                onClick={showUploadedFiles}
                                                className="btn btn-warning"
                                              >
                                                Cancel Upload
                                              </a>
                                            </center>
                                          ) : null}
                                          <Row style={{ display: "none" }}>
                                            <Col md={12}>
                                              <button
                                                ref={attachmentsFormRef}
                                                type="submit"
                                              >
                                                Upload Attachments
                                              </button>
                                            </Col>
                                          </Row>
                                        </form>
                                      </div>
                                    )}

                                    {/* {documentsPane} */}
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div className="row justify-content-center">
                              <Col lg="6">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>Proceed to submit Application</h5>
                                  </div>
                                </div>
                              </Col>
                            </div>
                            {editMode ? (
                              <AuthPlasticsPreview data={applicationDetails} />
                            ) : null}
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                toggleTab(activeTab - 1)
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              activeTab === 3 ? "next disabled" : "next"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                if (activeTab === 1) {
                                  plasticsFormRef.current.click()
                                } else if (activeTab === 2) {
                                  if (!disableFormFields) {
                                    if (!cancelUpload) {
                                      attachmentsFormRef.current.click()
                                    } else if (isFreshApplication) {
                                      attachmentsFormRef.current.click()
                                    } else if (!showDocuments) {
                                      attachmentsFormRef.current.click()
                                    } else {
                                      toggleTab(3)
                                    }
                                  }
                                } else {
                                  toggleTab(activeTab + 1)
                                }
                              }}
                            >
                              Next
                            </Link>
                          </li>
                          {activeTab === 3 ? (
                            <li style={{ float: "right" }}>
                              {loading ? (
                                <Link
                                  to="#"
                                  className="spinner-border text-info"
                                  style={{
                                    backgroundColor: "transparent",
                                    borderRadius: 20,
                                    padding: 0,
                                  }}
                                />
                              ) : (
                                <Link
                                  to="#"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    submitApplication()
                                  }}
                                  disabled={disableFormFields}
                                >
                                  Submit
                                </Link>
                              )}
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Card>
                <CardBody>
                  <div className="row justify-content-center">
                    <Col lg="6">
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Application succesfully submitted</h5>
                        </div>
                        {/* <li> */}
                        <Link
                          to="/dashboard"
                          className="btn btn-primary"
                          onClick={() => {
                            toggleTab(activeTab + 1)
                          }}
                        >
                          Back
                        </Link>
                        {/* </li> */}
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FormWizard
